import type { CanFrame } from './types';

function csvEscape(value: string | number | null) {
  const raw = value === null ? '' : String(value);
  return /[",\n]/.test(raw) ? `"${raw.replace(/"/g, '""')}"` : raw;
}

export function exportFramesCsv(frames: CanFrame[]) {
  const rows = [
    ['index', 'timestamp_ms', 'can_id', 'extended', 'dlc', 'data', 'delta_ms'],
    ...frames.map((frame) => [
      frame.index,
      frame.timestampMs.toFixed(3),
      frame.canIdHex,
      frame.extended ? 'true' : 'false',
      frame.dlc,
      frame.dataHex,
      frame.deltaMs === null ? '' : frame.deltaMs.toFixed(3)
    ])
  ];

  return rows.map((row) => row.map(csvEscape).join(',')).join('\n');
}
